import { Check, Globe, Lock } from "lucide-react";
import { Skeleton } from "../../../ui/skeleton";

interface GitRepository {
  id: string;
  name: string;
  fullName: string;
  private: boolean;
  defaultBranch: string;
  updatedAt?: string;
  language?: string;
}

interface RepoListProps {
  repos: GitRepository[];
  loading: boolean;
  selectedRepoId?: string;
  onSelect: (repo: GitRepository) => void;
  fillHeight?: boolean;
}

function SkeletonRow() {
  return (
    <div className="h-11 flex items-center px-3 gap-3">
      <Skeleton className="h-4 w-4 shrink-0" />
      <Skeleton className="h-3.5 flex-1" />
      <Skeleton className="h-3 w-16" />
    </div>
  );
}

export function RepoList({ repos, loading, selectedRepoId, onSelect, fillHeight }: RepoListProps) {
  return (
    <div className={`bg-card rounded-lg divide-y overflow-y-auto${fillHeight ? " flex-1 min-h-0" : " max-h-48"}`}>
      {loading && [0, 1, 2, 3].map((i) => <SkeletonRow key={i} />)}

      {!loading && repos.length === 0 && (
        <p className="py-8 text-center text-xs text-muted-foreground">
          No repositories found.
        </p>
      )}

      {!loading &&
        repos.map((repo) => (
          <button
            type="button"
            key={repo.id}
            onClick={() => onSelect(repo)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-muted/50 transition-colors ${
              selectedRepoId === repo.id ? "bg-muted" : ""
            }`}
          >
            {repo.private ? (
              <Lock className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            ) : (
              <Globe className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            )}
            <span className="flex-1 min-w-0">
              <span className="text-xs font-medium truncate block">{repo.fullName}</span>
              <span className="text-2xs text-muted-foreground">{repo.defaultBranch}</span>
            </span>
            {selectedRepoId === repo.id && (
              <Check className="h-3.5 w-3.5 text-primary shrink-0" />
            )}
          </button>
        ))}
    </div>
  );
}
